<template>
  <div class="row">
    <div class="flex">
      <div class="button-wrapper flex items-center mt-4 w-full gap-2 py-1 px-2 rounded">
        <span>{{ $t('documentation.api.downloadSpecs') }}</span>
        <div class="grow" />
        <a :href="`/api/v1/developer/api/file/${id}?format=yml&vendorId=${vendorId}`" type="button">
          <v-button label="YAML" dense appearance="filled" icon="download" size="condensed" />
        </a>
        <a :href="`/api/v1/developer/api/file/${id}?format=json&vendorId=${vendorId}`" type="button">
          <v-button label="JSON" dense appearance="filled" icon="download" size="condensed" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { VButton } from '@vonage/vivid-vue';
import { computed } from 'vue';

defineProps({ id: { type: String, required: true } });

const vendorId = computed(() => {
  return globalThis?.branding?.vendorId ?? '';
});
</script>

<style scoped lang="scss">
.button-wrapper {
  color: var(--vvd-color-canvas-text);
  border: 1px var(--vvd-color-neutral-600) solid;

  a {
    align-items: center;
  }
  @media screen and (max-width: $mobile-large) {
    flex-direction: column;
  }
  span {
    font: var(--vvd-typography-base-bold);
  }
}
</style>
